import { useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";

import { IOptionSelection } from "models/GlobalOptions/IGlobalOptionsSelections";
import { useTranslations } from "@fenetech/translations";
import useGlobalOptions from "components/GlobalOptions/useGlobalOptions";

const NewOptionSelection: React.FC<any> = () => {

    const tm = useTranslations();
    const { selections, onNewOptionChange } = useGlobalOptions();

    const selectedNewOption = useMemo(() => {
        let selection = selections.newOptionSelections?.find((q) => q.value === selections.selectedNewOption);

        if (!selection) {
            selection = { description: "", value: "" };
        }
        return selection;

    }, [selections]);


    return <>
        <Autocomplete
            autoComplete
            disableClearable
            autoSelect
            autoHighlight
            selectOnFocus
            handleHomeEndKeys
            options={selections.newOptionSelections}
            getOptionLabel={(s: IOptionSelection) => s.description}
            renderInput={(params) => (
                <TextField
                    {...params}
                    size="small"
                    label={tm.Get("New Option")}
                    InputProps={{
                        ...params.InputProps,
                    }}
                />
            )}
            onChange={(_, value) => onNewOptionChange(value.value)}
            value={selectedNewOption}
        />
    </>;
};


export default NewOptionSelection;
